import { ComumModule } from '../comum/comum.module';
import { Data } from '../comum/data/data';
import { PipesModule } from '../comum/filtros/pipes/pipes.module';
import { PontoFisicoService } from '../ponto-fisico/ponto-fisico.service';
import { ProcessoService } from '../processo/processo.service';
import { routing } from '../rotas';
import { RotinaService } from '../rotina/rotina.service';
import { SetorService } from '../setor/setor.service';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { NgxPaginationModule } from 'ngx-pagination';
import { PesquisaResultadoColetaComponent } from './pesquisa-resultado-coleta/pesquisa-resultado-coleta.component';
import { ResultadoColetaComponent } from './resultado-coleta/resultado-coleta.component';
import { FormsModule } from '@angular/forms';
import { ColetaService } from './coleta.service';
import { BrowserModule } from '@angular/platform-browser';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgbModule } from '@ng-bootstrap/ng-bootstrap';
import { NgxChartsModule } from '@swimlane/ngx-charts';
import { ProgressbarModule } from 'ngx-bootstrap';
import { LoadingModule, ANIMATION_TYPES } from 'ngx-loading';
import { CalendarModule, ConfirmDialogModule, ConfirmationService } from 'primeng/primeng';
import { MultiSelectModule } from 'primeng/primeng';
import { ModalDetalheColetasComponent } from './modal-detalhe-coletas/modal-detalhe-coletas.component';
import { DetalheColetasComponent } from './detalhe-coletas/detalhe-coletas.component';
import { ModalListaColetasComponent } from './modal-lista-coletas/modal-lista-coletas.component';
import { ListaColetasComponent } from './lista-coletas/lista-coletas.component';
import { CookieService } from 'angular2-cookie/services/cookies.service';
import { PesquisaInconsistenciasComponent } from './pesquisa-inconsistencias/pesquisa-inconsistencias.component';
import { ResultadoInconsistenciasComponent } from './resultado-inconsistencias/resultado-inconsistencias.component';
import { ListaInconsistenciasComponent } from './lista-inconsistencias/lista-inconsistencias.component';
import { ModalListaInconsistenciasComponent } from './modal-lista-inconsistencias/modal-lista-inconsistencias.component';
import { ModalListaColetasGraficoComponent } from './modal-lista-coletas-grafico/modal-lista-coletas-grafico.component';

@NgModule({
  imports: [
    CommonModule,
    NgxPaginationModule,
    NgbModule.forRoot(),
    PipesModule,
    ComumModule,
    routing,
    FormsModule,
    LoadingModule.forRoot({
      animationType: ANIMATION_TYPES.circle
    }),
    ProgressbarModule.forRoot(),
    BrowserModule,
    BrowserAnimationsModule,
    NgxChartsModule,
    CalendarModule,
    MultiSelectModule,
    ConfirmDialogModule
  ],
  declarations: [PesquisaResultadoColetaComponent, ResultadoColetaComponent, ModalDetalheColetasComponent,
    DetalheColetasComponent, ModalListaColetasComponent, ListaColetasComponent, PesquisaInconsistenciasComponent,
    ResultadoInconsistenciasComponent, ListaInconsistenciasComponent, ModalListaInconsistenciasComponent,
    ModalListaColetasGraficoComponent],
  exports: [PesquisaResultadoColetaComponent, ResultadoColetaComponent, ModalDetalheColetasComponent,
    DetalheColetasComponent, ModalListaColetasComponent, ListaColetasComponent, PesquisaInconsistenciasComponent,
    ResultadoInconsistenciasComponent, ListaInconsistenciasComponent, ModalListaInconsistenciasComponent,
    ModalListaColetasGraficoComponent],
  providers: [ColetaService, PontoFisicoService, SetorService, ProcessoService, RotinaService, Data, CookieService, ConfirmationService]
})
export class ColetaModule { }



// WEBPACK FOOTER //
// C:/Development/Projects/Sun/Flag/workspace/flagvarejoang4/src/app/coleta/coleta.module.ts